/* eslint-disable */ import { composedOfComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const anchorableShapeComponents = [
    attachComponent.withComponent(composedOfComponent, '$anchorPoints', true).withAlias('AnchorableShape').attach(memoEval((self)=>self.$anchorPoints.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        })))
];

//# sourceMappingURL=anchorable-shape.js.map